module.exports = __webpack_public_path__ + "img/coopeation.95efaf0b.png";